/*
* Copyright  2025-2026, Airspan
* All Rights Reserved
*
* This code is unpublished, confidential and proprietary to Airspan and may only be used in accordance with the appropriate
* license agreement. All other copying, modification, distribution, or
* reverse engineering are strictly prohibited.
*/

import { GridRowId } from "@mui/x-data-grid";
import { CircularProgress } from "@mui/material";
import { Button } from "../../ui/button";
import { Icon } from "../Icon";

interface IRemoveProps {
    id: string | number;
    isLoading: boolean;
    removeHandler: (id: GridRowId) => void;
}

const RemoveButton: React.FC<IRemoveProps> = ({
    id,
    isLoading,
    removeHandler
}) => (
    <div className="flex items-center">
        <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0 bg-transparent text-foreground hover:bg-accent hover:text-foreground" aria-label="Delete" onClick={() => removeHandler(id)}>
            {isLoading ? <CircularProgress size={20} color="primary" /> : <Icon name="delete" size={20} />}
        </Button>
    </div>
);

export default RemoveButton;


